export default __webpack_public_path__ + "static/performances-7352fc37a17fa1c842988f74212f3247.jpg";